
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaiairport() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Airport Cab',
        heading: 'Prince Cabs: Pune to Mumbai Airport Cab',
        headingDescription: 'Prince Cabs provides dependable Pune to Mumbai Airport Cab services, perfect for early morning flights, late-night departures, business travel, and family trips. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a smooth and timely journey along the expressway, with modern amenities for comfort. With professional chauffeurs, punctual pickups, and flexible schedules, we make sure you reach Mumbai Airport (T1 & T2) on time, stress-free. Choose Prince Cabs’ trusted Pune to Mumbai Airport taxi service for convenience, safety, and affordable fares.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most famous landmark, symbolizing the city’s colonial history and coastal charm. Overlooking the Arabian Sea, it is the starting point for ferry rides to Elephanta Caves. The Indo-Saracenic design makes it an architectural gem. Tourists gather here for photography, sea views, and evening strolls. The monument glows beautifully at sunset. It is the first stop for most visitors exploring Mumbai."
  },
  {
    "title": "Marine Drive",
    "description": "Known as the ‘Queen’s Necklace,’ Marine Drive is a 3.6 km-long promenade along the Arabian Sea. Its streetlights form a sparkling chain at night, attracting locals and tourists alike. People come here for jogging, long walks, and to witness mesmerizing sunsets. During monsoon, the crashing waves create a thrilling sight. It is one of Mumbai’s most romantic and iconic places. Marine Drive represents the city’s vibrancy and resilience."
  },
  {
    "title": "Elephanta Caves",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are ancient rock-cut caves located on Elephanta Island. Dating back to the 5th–6th century, they are primarily dedicated to Lord Shiva. The magnificent Trimurti sculpture is the highlight, depicting Shiva in three forms. Visitors take a one-hour ferry from Gateway of India to reach the island. The caves offer a blend of history, spirituality, and scenic sea views. They are a must-visit for heritage lovers."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "Formerly Victoria Terminus, CST is a UNESCO World Heritage railway station and architectural marvel. Built in 1887, it showcases Victorian Gothic Revival style with intricate carvings, stained glass, and domes. It is also one of India’s busiest train stations, showcasing Mumbai’s daily hustle. At night, the building lights up beautifully, making it a popular photography spot. CST is both a functional hub and a heritage monument. It captures the city’s colonial past and present energy."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an engineering marvel that connects Bandra to Worli over the Arabian Sea. This 8-lane cable-stayed bridge offers stunning views of Mumbai’s skyline. At night, it glows with lights, creating a spectacular sight. Driving over the bridge feels futuristic and thrilling. It reduces travel time while serving as a modern icon of Mumbai. Tourists often stop for photos capturing its grandeur against the sea."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, lined with food stalls selling pav bhaji, bhel puri, and ice gola. It is also known for Bollywood celebrity homes nearby, making it a hotspot for star spotting. Families flock here on weekends to enjoy the sea breeze and lively atmosphere. Sunsets at Juhu are breathtaking, with the beach turning into a carnival of activities. It is both a cultural and recreational landmark. The beach embodies Mumbai’s coastal lifestyle."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on a small islet off Worli. Dedicated to Pir Haji Ali Shah Bukhari, it is an Indo-Islamic masterpiece with white domes and courtyards. The shrine is accessible by a narrow causeway during low tide, adding to its charm. Thousands of devotees of all faiths visit daily. The dargah offers scenic sea views and spiritual peace. It symbolizes Mumbai’s harmony and faith."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Spread across 87 sq. km, Sanjay Gandhi National Park is a green oasis inside Mumbai. It is home to leopards, deer, and over 250 bird species. Within the park lie the Kanheri Caves, ancient Buddhist rock-cut caves dating back to the 1st century BC. They feature monasteries, stupas, and intricate carvings. Visitors can trek, cycle, or take a toy train through the park. It’s a unique mix of nature and history within a bustling city. A perfect getaway for families and explorers."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most vibrant street market, popular for shopping and food. It offers everything from clothes and jewelry to antiques and souvenirs. Legendary cafés like Leopold Café and Café Mondegar add to its charm. Tourists love the bustling vibe, bargain shopping, and colorful culture. Street art and colonial-era buildings enhance the experience. It is one of the best places to soak in Mumbai’s cosmopolitan energy. Shopping here is a must for travelers."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Located in Prabhadevi, Siddhivinayak Temple is Mumbai’s most revered temple dedicated to Lord Ganesha. Built in 1801, the temple attracts celebrities, politicians, and millions of devotees. The gold-plated dome and intricately carved interiors make it architecturally striking. Tuesdays are the busiest, with long queues of worshippers seeking blessings. It is believed that prayers here never go unanswered. The temple stands as a powerful spiritual landmark in Mumbai."
  },
  {
    "title": "Chowpatty Beach",
    "description": "Chowpatty Beach, located in South Mumbai, is famous for its Ganesh Visarjan celebrations. Families and tourists gather here for evening walks and street food. Vendors sell pav bhaji, bhel puri, kulfi, and other Mumbai favorites. The beach is lively during festivals and cultural events. Sunsets at Chowpatty are a major attraction. It is also close to Girgaon, known for its traditional chawls and temples. Together, they reflect Mumbai’s local culture and traditions."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Known as Bollywood’s home, Film City in Goregaon is spread across 520 acres with multiple studios and sets. Visitors can take guided tours to see shooting locations and film sets. It offers a glimpse into India’s largest film industry. From artificial villages to palace sets, it showcases the magic of cinema. Bollywood enthusiasts love exploring this behind-the-scenes hub. It is a unique attraction that connects Mumbai’s identity with the glamour of films."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is a serene artificial lake located in the heart of Mumbai. Surrounded by lush gardens and modern skyscrapers, it offers a scenic escape from city chaos. The lake attracts bird watchers, with sightings of kingfishers, herons, and migratory species. Locals visit for morning walks and photography. During monsoon, the lake becomes especially picturesque. It is a calm retreat blending nature with urban life. Powai adds greenery to Mumbai’s modern landscape."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "Located near Gorai, the Global Vipassana Pagoda is a massive meditation dome dedicated to world peace. Built in Burmese architectural style, it houses relics of Buddha and can seat over 8,000 meditators. The golden dome is one of the largest stone monuments in the world without supporting pillars. Visitors come for guided meditation sessions and spiritual learning. Its tranquil setting away from the city makes it a soul-soothing destination. The pagoda is both a spiritual and architectural wonder."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium, located at Worli, is a hub for astronomy lovers and students. It hosts shows on space, stars, and planets with advanced projection systems. The adjoining Nehru Science Centre offers interactive exhibits on science and technology. Visitors also explore the dome-shaped auditorium and art galleries. It is educational and entertaining for children and adults alike. Together, they make a cultural and scientific landmark of Mumbai. Perfect for families seeking an informative day out."
  }
],


"services": [
    {
        "name": "Pune to Mumbai Airport Cab Price",
        "description": "Get transparent and competitive cab pricing for transfers from Pune to Mumbai Airport. Our all-inclusive fares cover tolls, driver charges, and taxes, ensuring no hidden costs. Choose from a variety of vehicles to suit your comfort and budget requirements."
    },
    {
        "name": "Pune to Mumbai Airport Innova Crysta",
        "description": "Travel comfortably in an Innova Crysta from Pune to Mumbai Airport. This spacious and air-conditioned vehicle is perfect for families and groups who want a smooth and stress-free airport transfer experience with professional drivers."
    },
    {
        "name": "Pune to Mumbai Airport Drop Innova",
        "description": "Book an Innova for airport drop service from Pune to Mumbai Airport. Our drivers ensure timely pickups and drop-offs, monitor your flight schedules, and provide a hassle-free ride in a clean, well-maintained vehicle."
    },
    {
        "name": "Pune to Mumbai Innova Airport Taxi",
        "description": "Reliable Innova airport taxi service from Pune to Mumbai with experienced drivers, comfortable seating, and ample luggage space. Ideal for business travelers and families looking for a premium airport transfer."
    },
    {
        "name": "Pune to Mumbai Airport Swift Dzire Drop",
        "description": "Affordable Swift Dzire taxi drop service from Pune to Mumbai Airport. Perfect for solo travelers and small families, offering a smooth ride, air conditioning, and punctual service."
    },
    {
        "name": "Pune to Mumbai Airport Taxi",
        "description": "Convenient and reliable taxi service for transfers between Pune and Mumbai Airport. Choose from a fleet of well-maintained vehicles and professional drivers to ensure you reach your flight on time and in comfort."
    },
    {
        "name": "Pune to Mumbai Airport Etios Cab",
        "description": "Travel in a fuel-efficient Toyota Etios cab from Pune to Mumbai Airport. This sedan offers comfort, air conditioning, and professional service at an affordable price, suitable for individual travelers and small groups."
    },
    {
        "name": "Pune to Mumbai Airport Affordable Cab",
        "description": "Budget-friendly airport cab service from Pune to Mumbai offering reliable rides without compromising safety or comfort. Transparent pricing and courteous drivers make your airport transfer hassle-free."
    },
    {
        "name": "Pune to Mumbai Airport Round Trip Taxi",
        "description": "Book a round-trip taxi for seamless travel between Pune and Mumbai Airport. Enjoy the convenience of a dedicated driver and vehicle throughout your journey with flexible pick-up and drop-off timings."
    },
    {
        "name": "Pune to Mumbai Airport Dzire Taxi",
        "description": "Comfortable and economical Dzire taxi service for Pune to Mumbai Airport transfers. Ideal for couples and small groups seeking a reliable and air-conditioned ride with experienced drivers."
    },
    {
        "name": "Pune to Mumbai Airport Family Cab",
        "description": "Family-friendly cab service from Pune to Mumbai Airport with extra space, child seats on request, and courteous drivers to ensure a safe and comfortable trip for all family members."
    }
],
"tableData": [
    ["Pune to Mumbai Airport Cab Price", "Pune to Mumbai Airport Innova Crysta"],
    ["Pune to Mumbai Airport Drop Innova", "Pune to Mumbai Innova Airport Taxi"],
    ["Pune to Mumbai Airport Swift Dzire Drop", "Pune to Mumbai Airport Taxi"],
    ["Pune to Mumbai Airport Etios Cab", "Pune to Mumbai Airport Affordable Cab"],
    ["Pune to Mumbai Airport Round Trip Taxi", "Pune to Mumbai Airport Dzire Taxi"],
    ["Pune to Mumbai Airport Family Cab", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Airport Cab Service",
        "WhyChoosedescription": "Prince Cabs offers punctual and comfortable cab services from Pune to Mumbai Airport, perfect for timely airport transfers ensuring you never miss your flight."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in well-maintained, air-conditioned cabs with ample legroom and luggage space, designed to make your airport journey smooth and hassle-free."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Airport Routes",
        "WhyChoosedescription": "Our professional drivers have in-depth knowledge of the best routes to Mumbai Airport, ensuring timely arrivals even during peak traffic hours."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Match Your Flight Schedule",
        "WhyChoosedescription": "Book one-way or round-trip cabs with ease, tailored to your flight timings. Our flexible packages accommodate early morning or late-night airport transfers."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "Each cab is thoroughly cleaned and sanitized before every trip. We prioritize your health and safety with regular vehicle maintenance and safety features."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Methods",
        "WhyChoosedescription": "Enjoy clear, upfront pricing with no hidden charges. We accept secure payments via UPI, credit/debit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Stress-Free Transfer",
        "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you with bookings, flight delays, or any travel concerns to ensure a smooth Pune to Mumbai Airport cab experience."
    }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Mumbai Airport cab services?',
        answer: 'Yes, Prince Cabs specializes in Pune to Mumbai Airport cab services, offering timely pickups and comfortable rides to both domestic and international terminals.',
    },
    {
        question: 'What types of cabs are available for Pune to Mumbai Airport transfers?',
        answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers to suit solo travelers, families, and corporate clients with varying luggage needs.',
    },
    {
        question: 'Are your drivers punctual and experienced for airport travel?',
        answer: 'Absolutely! Our drivers are trained, professional, and punctual—ensuring you reach Mumbai Airport on time, every time.',
    },
    {
        question: 'Can I schedule an early morning or late-night cab to Mumbai Airport?',
        answer: 'Yes, we provide 24/7 cab services. You can pre-book a cab for any time—early morning, late night, or even last-minute travel.',
    },
    {
        question: 'What are the charges for Pune to Mumbai Airport cab service?',
        answer: 'Fares depend on the cab type, timing, and additional requirements. Contact Prince Cabs for an accurate and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Mumbai Airport cab with Prince Cabs?',
        answer: 'Booking is simple—call us or book through our website. Share your flight details and pickup location, and we’ll take care of the rest.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for airport travel?',
        answer: 'Yes, all our vehicles are regularly sanitized, cleaned, and serviced to provide a hygienic and safe airport travel experience.',
    },
];

const testimonials = [
    {
        name: "Mr. Ramesh Pawar",
        position: "International Traveler",
        text: "Prince Cabs got me to Mumbai Airport from Pune on time for my flight. The service was prompt and the car was in excellent condition.",
        image: "/img/testimonial/testimonial-thumb-airport-1.png",
    },
    {
        name: "Ms. Divya Mehta",
        position: "Frequent Flyer",
        text: "I always book my Pune to Mumbai Airport cab with Prince Cabs. They’re reliable, safe, and always on time—even during odd hours.",
        image: "/img/testimonial/testimonial-thumb-airport-2.png",
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab",
  "image": "https://princecab.com/assets/images/pune-mumbai-airport-cab.jpg",
  "description": "Book Pune to Mumbai Airport cab with Prince Cabs – Affordable airport drop service with clean and reliable vehicles like Innova Crysta, Dzire, and Etios. One-way and round-trip options available. 24/7 booking support.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "7085"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-mumbai-airport-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Airport Cab | Safe Airport Drop Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Mumbai Airport cab service with clean Dzire, Etios, and Innova Crysta cabs. On-time pickup, professional drivers, and 24/7 online booking for both one-way and round-trip options."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Cab Price, Pune to Mumbai Airport Innova Crysta, Pune to Mumbai Airport Drop Innova, Pune to Mumbai Innova Airport Taxi, Pune to Mumbai Airport Swift Dzire Drop, Pune to Mumbai Airport Taxi, Pune to Mumbai Airport Etios Cab, Pune to Mumbai Airport Affordable Cab, Pune to Mumbai Airport Round Trip Taxi, Pune to Mumbai Airport Dzire Taxi, Pune to Mumbai Airport Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiairport;